<template>
  <div class="user-qr-reader-box">
    <div class="main-container">
      <h2 class="">{{$t('page_title')}}</h2>

      <p class="about">{{ $t('about') }}</p>

      <div class="qr-box">
        <qrcode-stream :paused="paused" @init="onInit" @decode="onDecode"></qrcode-stream>
      </div>
      <div class="bottom-btn-box">
        <input type="button" class="button" @click="back" :value="$t('back')" />
      </div>

    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
export default {
  name: 'UserQrReader',
  language: {
    'ja': {
      'page_title': 'チェックインQR読み込み',
      'about': 'エントランスでチェックイン用QRコードを読み取ってください',
      'back': 'キャンセル',
      'qr_read_error': 'StayAssistのチェックインQRにかざしてください',
      'accept_ok': 'チェックイン操作は完了しています',
    },
    'en': {
      'page_title': 'Check-in QR reading',
      'about': 'Please scan the check-in QR code at the entrance.',
      'back': 'back',
      'qr_read_error': 'Please hold it over the StayAssist check-in QR.',
      'accept_ok': 'Check-in operation has been completed.',
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    QrcodeStream
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      check_in_status: 0,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('user_status_get.php');
    },
    data_get_cb (res) {
      this.check_in_status = res.data.check_in_status;
      if (this.check_in_status == 1 || this.check_in_status == 2) {
        this.$alert('info', this.$t('accept_ok'));
        this.$router.replace({ name: 'user_list_info', params: {} });
      }
    },

    async onInit(promise) {
      // show loading indicator
      try {
        await promise;
        // successfully initialized
      } catch (error) {
        console.log(error);
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
        } else if (error.name === 'OverconstrainedError') {
          // passed constraints don't match any camera. Did you requested the front camera although there is none?
        } else {
          // browser is probably lacking features (WebRTC, Canvas)
        }
      } finally {
        // hide loading indicator
      }
    },
    onDecode(content) {
      console.log(content);
      // console.log((new Function("return " + content))());
      this.paused = true;

      try {
        const res = JSON.parse(content);
        console.log(res.type);
        if (res.type === 'lcpe_checkin_qr') {
          // チェックインQR
          this.$router.push({ name: res.url, params: {} });
        } else {
          this.$alert('alert', this.$t('qr_read_error'));
        }
      }
      catch {
        this.$alert('alert', this.$t('qr_read_error'));
      }
    },
    back() {
      this.$router.back();
    }

  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-qr-reader-box {
  text-align: left;

  .main-container {
    padding-bottom: 54px;
    .about {
      padding: 0 0 0 10px;
    }
    .qr-box {
      max-width: 400px;
      margin: 32px auto 0 auto;
      padding: 16px;
      border: 1px solid #999;
      aspect-ratio: 1;
    }
    .bottom-btn-box {
      display: flex;
      margin: 40px;
      justify-content: center;
    }

    .button {
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }
  }
  @media (max-width: 767px) {
    .main-container {
    }
  }
}
</style>
